import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/components/form/horizontal/icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b087e78e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b087e78e', __exports__)) {
    console.log('reload')
    api.reload('b087e78e', __exports__)
  }
  
}


export default __exports__